import { entities } from '@palette/state/entities';

const reducers = entities.reduce((res, entity) => ({
  ...res,
  [entity.slice.name]: entity.slice.reducer,
}), {});

export default reducers;
